export function showPageLoader () {
  const style = getPageLoader()
  if (style) {
    style.innerHTML = ''
  }
}

function getPageLoader () {
  const head = document.head || document.getElementsByTagName('head')[0]
  for (let i = 0; i < head.children.length; i++) {
    if (head.children[i].hasAttribute('id') && head.children[i].getAttribute('id') === 'hide-page-loader-style') {
      return head.children[i]
    }
  }
}

export function hidePageLoader () {
  setTimeout(() => {
    const css = 'body:before{display:none}'
    let style = getPageLoader()
    if (style) {
      style.appendChild(document.createTextNode(css))
    } else {
      const head = document.head || document.getElementsByTagName('head')[0]
      style = document.createElement('style')
      style.setAttribute('type', 'text/css')
      style.styleSheet ? style.styleSheet.cssText = css : style.appendChild(document.createTextNode(css))
      style.setAttribute('id', 'hide-page-loader-style')
      head.appendChild(style)
    }
  }, 500)
}
